import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon } from "@heroicons/react/outline";
import clsx from "clsx";
import React from "react";

interface AlertProps {
  type?: "success" | "error" | "info" | "warning";
  title: string;
  message: string;
  classes?: string;
}

export function Alert({ type = "info", title, message, classes }: AlertProps) {

  const iconClasses = "w-8 h-8";

  return <div className={clsx("p-4 rounded-md flex items-center space-x-2 border",
    {
      "info": "bg-blue-100 text-blue-800 border-blue-400",
      "error": "bg-red-100 text-red-800 border-red-400",
      "warning": "bg-yellow-100 text-yellow-800 border-yellow-400",
      "success": "bg-green-100 text-green-800 border-green-400"
    }[type], classes)}>
    <div>
      {{
        "info": <InformationCircleIcon className={iconClasses} />,
        "error": <ExclamationCircleIcon className={iconClasses} />,
        "warning": <ExclamationCircleIcon className={iconClasses} />,
        "success": <CheckCircleIcon className={iconClasses} />
      }[type]}
    </div>
    <div>
      <h4 className="font-bold">{title}</h4>
      <p className="text-sm">{message}</p>
    </div>
  </div>

}